export default "__VITE_ASSET__DHLdGfqP__"